<template>
    <div class="generic-container">
      <header :class="[{ fadeIn: stateManager.animationEnabled}, 'bgSea', 'xs' ]">
        <h1><router-link :to="psalmPath">{{ currentPsalm.titleWithNumber }} ({{ currentPsalm.title }})</router-link></h1>
      </header>

      <div class="verse-content" v-if="currentPsalm && currentVerse">
        
        
        <div class="prose">
          <div class="prose-row"><h2 style="opacity: .4;">Versetto {{ verse }}</h2></div>
          <!-- <VerseActionItems :verse="verse" favoriteVerses="[1,2]" :fullScreen="true" /> -->
          <div class="prose-row" style="font-size: 1.5rem; padding: 1rem 2rem 2rem 2rem; font-weight: 600;">
            
            <span class="row-quote-icon">«</span>
            {{ currentVerse }}
            <span class="row-quote-icon">»</span>

          </div>
        </div>
      </div>

      <div class="menu-b">
        <button v-on:click="goBack()" :disabled="verse <= 1">
          Versetto Precedente <span class="combo"><span>CTRL</span><span>&longleftarrow;</span></span>
        </button>
        <button v-on:click="goNext()" :disabled="verse >= currentPsalm['content'].length">
          Versetto Successivo <span class="combo"><span>CTRL</span><span>&longrightarrow;</span></span>
        </button>
      </div>
    </div>
</template>

<script setup>
import { stateManager } from '@/stateManager';
import salmi from "@/assets/json/salmi.json";
import { useRoute, useRouter } from "vue-router";
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { updatePageDescription, updatePageTitle } from '@/libs/utils';
import VerseActionItems from '@/components/VerseActionItems.vue';
const route = useRoute()
const router = useRouter();

const psalmNumber = Number(route.params.number);
const psalmPath = `/s/${psalmNumber}`;
const verse = ref(Number(route.params.verse));
const items = salmi.items;
const currentPsalm = items[psalmNumber - 1];
const currentVerse = ref(currentPsalm["content"][verse.value - 1]);


onMounted(() => {
  // update page title and description
  updatePageTitle(document, `${currentPsalm["titleWithNumber"]}, Versetto ${verse.value}.`);
  updatePageDescription(document, currentVerse.value);
  window.addEventListener('keyup', onKeyUp)
})

onBeforeUnmount(() => { window.removeEventListener('keyup', onKeyUp) });

watch(() => route.params.verse, newValue => {
  if(newValue){ 
    update(newValue);
    updatePageTitle(document, `${currentPsalm["titleWithNumber"]}, Versetto ${verse.value}.`);
    updatePageDescription(document, currentVerse.value);
  }
}) 

function update(newValue) {
  newValue = Number(newValue)
  verse.value = newValue;
  currentVerse.value = currentPsalm["content"][verse.value - 1];
}

function goBack() {
  router.push(`/s/${psalmNumber}/v/${verse.value-1}`)
}

function goNext() {
  router.push(`/s/${psalmNumber}/v/${verse.value+1}`)
}

function onKeyUp(e) {
  if(e.ctrlKey && e.key === 'ArrowRight' && verse.value < currentPsalm['content'].length) 
    goNext();
  else if(e.ctrlKey && e.key === 'ArrowLeft' && verse.value > 1) 
    goBack();
  }
</script>

<style scoped>
    /* .prose .prose-row .verse-link */
</style>